<template>
  <div>
    <button
      v-for="(tab, index) in filteredTabs"
      :key="index"
      class="mr-2 btn btn-outline-primary"
      @click="navigate(tab.route)"
    >
      {{ tab.label | t }}
    </button>
    <template v-if="can('write_customer_tokens')">
      <i
        class="mr-2 fa fa-keyboard-o"
        v-if="canCopyLocalImpersonationLink"
        @click="impersonateInLocalFrontend"
        type="button"
        v-tooltip="$t('impersonate_in_local_development')"
      ></i>
      <div class="mr-2 btn-group">
        <button class="btn btn-primary" @click="impersonate">
          {{ "impersonate" | t }}
        </button>
        <button
          class="btn btn-primary dropdown-toggle dropdown-toggle-split"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span class="sr-only"></span>
        </button>
        <div class="dropdown-menu dropdown-menu-scroll">
          <a
            class="dropdown-item"
            v-for="user in users"
            :key="user.id"
            @click="impersonateUser(user)"
          >
            {{ user.first_name }} {{ user.email }}
          </a>
        </div>
      </div>
    </template>
    <button
      v-for="(action, index) in filteredActions"
      :key="index"
      class="btn btn-success"
      @click="action.method"
    >
      {{ action.label | t }}
    </button>
    <router-link
      class="btn btn-outline-primary"
      :to="{ name: 'customers_edit', customer_id: customer.id }"
      tag="button"
      v-if="currentTab === 'customer' && can('write_customers')"
    >
      {{ "edit_customer" | t }}
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    currentTab: String,
    customer: Object,
    users: Array,
    canCopyLocalImpersonationLink: Boolean
  },
  data() {
    return {
      tabs: [
        {
          name: "purchases",
          route: { name: "new-purchase-form" },
          label: "new_purchase",
        },
        {
          name: "payments",
          route: { name: "payment-form" },
          label: "new_payment",
        },
        {
          name: "invoices",
          route: { name: "invoice-form" },
          label: "new_invoice",
        },
        {
          name: "invoices",
          route: { name: "invoice-form" },
          label: "new_invoice_no_credit_memos",
        },
        {
          name: "staff_accesses",
          route: { name: "customer-staff-access-form" },
          label: "new_staff_access",
        },
      ],
      actions: [
        { tab: "users", method: this.emitCreateUser, label: "create_user" },
        {
          tab: "discounts",
          method: this.emitCreateDiscount,
          label: "create_discount",
        },
      ],
    };
  },
  computed: {
    filteredTabs() {
      return this.tabs.filter((tab) => {
        if (this.currentTab === "invoices") {
          if (this.can("write_credit_memo")) {
            return tab.label === "new_invoice";
          } else {
            return tab.label === "new_invoice_no_credit_memos";
          }
        } else {
          return this.currentTab === tab.name;
        }
      });
    },
    filteredActions() {
      return this.actions.filter(
        (action) =>
          this.currentTab === action.tab && this.can("write_customers")
      );
    },
  },
  methods: {
    navigate(route) {
      this.$router.push(route);
    },
    impersonate() {
      this.$emit("impersonate");
    },
    impersonateInLocalFrontend() {
      this.$emit("impersonateInLocalFrontend");
    },
    impersonateUser(user) {
      this.$emit("impersonateUser", user);
    },
    emitCreateDiscount() {
      this.$emit("createDiscount");
    },
    emitCreateUser() {
      this.$emit("createUser");
    },
  },
};
</script>
